import { TechTuningRarity } from '~/shared';

export enum ColorGradient {
	Green = 'radial-gradient(50% 50% at 50% 50%, #3BB200 0%, #1C5500 100%)',
	Blue = 'radial-gradient(50% 50% at 50% 50%, #2D70D9 0%, #00317D 100%)',
	Red = 'radial-gradient(50% 50% at 50% 50%, #FF0013 0%, #8D000B 100%)',
	Gold = 'radial-gradient(50% 50% at 50% 50%, #E39B00 0%, #9E6C00 100%)',
	Purple = 'radial-gradient(50% 50% at 50% 50%, #A200FF 0%, #4F007C 100%)',
}

export const TuningShopRarityColors = {
	[TechTuningRarity.COMMON]: '#2D70D9',
	[TechTuningRarity.UNCOMMON]: '#A200FF',
	[TechTuningRarity.RARE]: '#3BB200',
	[TechTuningRarity.EPIC]: '#E39B00',
	[TechTuningRarity.LEGENDARY]: '#FF0013',
};

export const TuningShopRarityGradientColors = {
	[TechTuningRarity.COMMON]: ColorGradient.Blue,
	[TechTuningRarity.UNCOMMON]: ColorGradient.Purple,
	[TechTuningRarity.RARE]: ColorGradient.Green,
	[TechTuningRarity.EPIC]: ColorGradient.Gold,
	[TechTuningRarity.LEGENDARY]: ColorGradient.Red,
};
